export const sentenceCase = (str: string): string => {
  const s = str.trim();
  return s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : '';
};

export const titleCase = (str: string): string => {
  const s = str?.trim();
  if (!s) return '';

  return s
    .split(/\s+/)
    .map(word =>
      word
        .split('-')
        .map(part => (part ? part[0].toUpperCase() + part.slice(1).toLowerCase() : ''))
        .join('-'),
    )
    .join(' ');
};

export const generateUUID = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const isEmpty = (val?: string) => (val?.trim() ?? '') === '';

export const isNullOrEmpty = (val?: string) => val === null || val === undefined || val?.trim() === '';

export const isString = (value: any): value is string => typeof value === 'string';
